import React, { Component } from "react";
import { connect } from "react-redux";
import * as userActions from "./store/actions";
import { bindActionCreators } from "redux";
// import * as Actions from 'app/store/actions';
import jwtService from "../services/jwtService";

class Auth extends Component {
  /*eslint-disable-next-line no-useless-constructor*/
  constructor(props) {
    super(props);

    this.jwtCheck();
  }

  jwtCheck = () => {
    jwtService.on("onAutoLogin", () => {
      // this.props.showMessage({message: 'Logging in with JWT'});
      console.log("Logging in with JWT");

      /**
       * Sign in and retrieve user data from Api
       */
      // jwtService
      //   .signInWithToken()
      //   .then((user) => {
      //     console.log(user);
      //     // this.props.setUserData(user);

      //     // this.props.showMessage({message: 'Logged in with JWT'});
      //     console.log("Logged in with JWT");
      //   })
      //   .catch((error) => {
      //     // this.props.showMessage({message: error});
      //     console.log(error);
      //     this.props.logout();
      //   });
    });

    jwtService.on("onAutoLogout", (message) => {
      if (message) {
        // this.props.showMessage({message});
        console.log(message);
      }
      this.props.logout();
    });

    jwtService.init();
  };

  render() {
    const { children } = this.props;

    return <React.Fragment>{children}</React.Fragment>;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout: userActions.logoutUser,
      setUserData: userActions.setUserData,
      // showMessage        : Actions.showMessage,
      // hideMessage        : Actions.hideMessage
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(Auth);
